// extracted by mini-css-extract-plugin
module.exports = {"container":"add-comment_container__2Asy5","button":"add-comment_button__vYECB","status":"add-comment_status__2FRfd"};